export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5651.3fb336fa.jpg";